export class LocalStorageKey{
    static kTicketID = 'kTicketId';
    static kTicketAuth = 'kTicketAuth';
}